import { computed, Injectable, signal } from '@angular/core';
import { Element, Page, PageType } from '@hyper-inferno/survey-elements-core';

@Injectable({
  providedIn: 'root',
})
export class DataStoreService {
  surveyId = signal<number | undefined>(undefined);
  pages = signal<Page[]>([]);
  setPages(pages: Page[]) {
    this.pages.set([...pages]);
  }
  questions = signal<Element[]>([]);
  setQuestions(questions: Element[]) {
    this.questions.set([...questions]);
  }

  //  pages with display labels
  pagesWithDisplay = computed(() => {
    const pages = this.pages();
    let elementCounter = 0;
    let logicCounter = 0;
    let endingCounter = 0;

    // Sort pages by block rank and page rank
    const sortedPages = [...pages].sort((a, b) => {
      // Your sorting logic here
      return (a.rank ?? 0) - (b.rank ?? 0);
    });

    return sortedPages.map((page) => {
      let normalized_rank: number;
      let display_label: string;

      if (page.type === PageType.ENDING_PAGE_MODEL) {
        endingCounter++;
        normalized_rank = endingCounter;
        display_label = `Ending Page ${endingCounter}`;
      } else if (page.type === PageType.LOGIC_PAGE_MODEL) {
        logicCounter++;
        normalized_rank = logicCounter;
        display_label = `Logic Page ${logicCounter}`;
      } else {
        elementCounter++;
        normalized_rank = elementCounter;
        display_label = `Page ${elementCounter}`;
      }

      return {
        ...page,
        normalized_rank,
        display_label,
      };
    });
  });
}
